function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 1,
  y: 1,
  width: 19,
  height: 19,
  rx: 4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.63405 13.7196C8.86494 14.4399 7.66889 14.4399 6.89978 13.7196L5.03519 11.9734C4.47477 11.4485 4.47477 10.5592 5.03519 10.0344V10.0344C5.54654 9.55547 6.34192 9.55605 6.85256 10.0357L8.26691 11.3642L14.1471 5.85163C14.6581 5.37259 15.4531 5.37239 15.9643 5.85117V5.85117C16.525 6.37626 16.525 7.26595 15.9643 7.79104L9.63405 13.7196Z"
});

var SvgCheckedItem = function SvgCheckedItem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckedItem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked-item.f5331e6f.svg";
export { ForwardRef as ReactComponent };